import { useMemo } from "react";

const useSearch = (list = [], searchKey = "", searchableFields = []) => {
  const filteredList = useMemo(() => {
    const normalizedSearchKey = normalize(searchKey);
    if (!normalizedSearchKey) return list;

    return list.filter(item =>
      searchableFields.some(field => 
        normalize(String(item[field] ?? "")).includes(normalizedSearchKey))
    );
  }, [list, searchKey, searchableFields]);

  return filteredList;
}

export default useSearch;

const normalize = (str) =>
  str
    ?.normalize("NFKC")
    .replace(/[\u2012-\u2015]/g, "-") // replace various dashes with hyphen (-)
    .replace(/\u00A0/g, " ")          // replace non-breaking spaces
    .toLowerCase();